import { FC, FormEvent } from "react";
import KickImage from 'Reuseables/KickImage';
import DropdownIcon from "../../../images/dropdown-icon.png";

import styled from "styled-components";

import { FontFamilyBold, FontFamilyRegular } from "../../../constants";

// Define Interface
interface option {
  value: string;
  text: string;
}

type Props = {
  className?: string;
  errorMessage?: string;
  title?: string;
  placeholder?: string;
  type?: string;
  name?: string;
  readonly?: boolean;
  options?: option[];
  icon?: string;
  min?: string;
  value?: string,
  selectValue?: string,
  onChange?: (e: FormEvent<HTMLInputElement>) => void;
  onSelect?: (e: FormEvent<HTMLSelectElement>) => void;
}

// STYLED COMPONENT
interface CustomInputWithDropdownCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
  marginBottom?: string;
}
const CustomInputWithDropdownComp = styled.div<CustomInputWithDropdownCompProps>`
  width: 100%;
  margin-bottom: ${props => props.marginBottom};
  .title{
    font-family: ${props => props.fontFamilyRegular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #242424;
    margin-bottom: 8px;
  }
  .input-wrapper{
    padding: 16px;
    border-radius: 8px;
    border: solid 1px #ebebeb;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .dropdown{
      display: flex;
      align-items: center;
      margin-right: 8px;
      cursor: pointer;
      select{
        border: unset;
        font-family: ${props => props.fontFamilyRegular};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #242424;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin-right: 4px;
        cursor: pointer;
        &:focus-visible{
          outline: 0;
        }
      }
      .arrow-icon{
        width: 10px;
        height: 6px;
        object-fit: contain;
      }
    }

    input{
      width: 100%;
      border: unset;
      box-shadow: unset;
      font-family: ${props => props.fontFamilyRegular};
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #242424;
  
      &::placeholder {
        font-family: ${props => props.fontFamilyRegular};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #bebebe;
      }

      &:focus-visible{
        outline: 0;
      }
    }
  }
  .error-message{
    color: #ea4c60;
    font-family: ${props => props.fontFamilyRegular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    margin-bottom: 0;
    margin-top: 8px;
  }
`
CustomInputWithDropdownComp.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular,
  marginBottom: "16px"
}

// MAIN COMPONENT
const CustomInputWithDropdown: FC<Props> = ({
  icon,
  options,
  errorMessage,
  type,
  title,
  value,
  selectValue,
  placeholder,
  className,
  readonly,
  min,
  name,
  onChange,
  onSelect
}) => {
  const keypressHandler = (e) => {
    const event = e || window.event;

    // Handle key only accept number
    let key = event.keyCode || event.which;
    key = String.fromCharCode(key);

    const regex = /[0-9]|\./;

    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) event.preventDefault();
    }
  }

  const RenderSelectOptions = () => {
    if (!options?.length && selectValue) return (
      <select>
        <option selected>+{selectValue}</option>
      </select>
    )

    return (
      <select name={name} onChange={onSelect}>
        {
          options?.length ? options?.map((opt, idx) => {
            return <option selected={selectValue === opt.value} key={idx} value={opt.value}>{opt.text}</option>
          }) : null
        }
      </select>
    )
  }
  
  const RenderInput = () => {
    if (type === "number") return (
      <input
        name={name}
        value={value}
        readOnly={readonly}
        onChange={onChange}
        placeholder={placeholder}
        onKeyPress={keypressHandler}
        type="text"
      />
    )
    return (
      <input
        name={name}
        value={value}
        readOnly={readonly}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
      />
    )
  }
  return (
    <CustomInputWithDropdownComp className={className}>
      <p className="title">{title}</p>
      <div className="input-wrapper">
        <div className="dropdown">
          {RenderSelectOptions()}
          <KickImage src={icon || DropdownIcon} className="arrow-icon" alt="dropdown" />
        </div>
        {RenderInput()}
      </div>
      {errorMessage ? <p className="error-message">{errorMessage}</p> : null}
    </CustomInputWithDropdownComp>
  )
}
CustomInputWithDropdown.defaultProps = {
  errorMessage: "",
  title: "",
  name: "",
  placeholder: "",
  className: "",
  readonly: false,
  icon: "",
  value: "",
  min: "0",
  selectValue: "",
  type: "text",
  options: [],
  onChange: (e) => { },
  onSelect: (e) => { }
}

export default CustomInputWithDropdown